import { menuItemClasses } from '@ori-ui/mui-bundle/material';
import { colors, textInputData } from '../constants';
import { selectedMark } from '../constants/textInputData';
const styleOverrides = {
  root: {
    [`&.OriSelectList .${menuItemClasses.root}`]: {
      fontSize: textInputData.input.size,
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 10,
      paddingRight: 12
    },
    [`&.OriSelectList .${menuItemClasses.root}::after`]: {
      content: '""',
      flexShrink: 0,
      display: 'block',
      overflow: 'hidden',
      width: '24px',
      height: '24px',
      background: 'transparent'
    },
    [`&.OriSelectList .${menuItemClasses.root}:focus`]: {
      backgroundColor: colors.primary.light
    },
    [`&.OriSelectList .${menuItemClasses.root}:hover`]: {
      backgroundColor: colors.primary.light
    },
    [`&.OriSelectList .${menuItemClasses.selected}:focus`]: {
      backgroundColor: 'transparent'
    },
    [`&.OriSelectList .${menuItemClasses.selected}:hover`]: {
      backgroundColor: colors.primary.light
    },
    [`&.OriSelectList .${menuItemClasses.selected}::after`]: {
      content: selectedMark
    }
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiList.js.map